import { useQuery } from "react-query";
import { get, downloadFile, OK_RESPONSE } from "../../../../http";
import { bulkDownloadFileUrl, bulkDownloadFileKey } from "./downloadFile.constants";

export function useDownloadFileQuery(fileKey: string) {
  const queryUrl = `${bulkDownloadFileUrl}/${fileKey}`;
  const queryKey = `${bulkDownloadFileKey}/${fileKey}`;
  const { isLoading, isError, isSuccess } = useQuery(queryKey, () => downloadExportFile(queryUrl));
  return { isDownloadFileLoading: isLoading, isDownloadFileError: isError, isDownloadFileSuccess: isSuccess };
}

async function downloadExportFile(url: string) {
  try {
    const res = await get(url, undefined, {
      headers: {
        Accept: "*/*",
      },
    });

    if (res.status === OK_RESPONSE) {
      const blob = await res.blob();
      const filename = decodeURIComponent(
        res.headers
          .get("Content-Disposition")
          ?.split("; ")
          .find((x) => x.includes("filename*=UTF-8''"))
          ?.split("''")[1] ?? ""
      );
      downloadFile(blob, filename);
    }
  } catch (err) {
    console.error(err);
  }
}
